/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import * as yup from "yup";
import { FormRow } from "../../../module/common/hook-form/FormRow";
import { TextInput } from "./TextInput";

const wrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const addressPartsSchema = {
  addressLine: yup
    .string()
    .max(512, "Street address cannot be longer than 512 characters"),
  addressLine2: yup
    .string()
    .max(512, "Address line 2 cannot be longer than 512 characters"),
  postcode: yup
    .string()
    .test(
      "postcode-length",
      "Postcode must be between 3 and 20 characters, or empty",
      (value) => !value || (value.length >= 3 && value.length <= 20)
    ),
  city: yup.string().max(255, "City cannot be longer than 255 characters"),
};

export const AddressPartsInputs = ({ className }: { className?: string }) => (
  <div css={wrapperStyle} className={className}>
    <FormRow>
      <TextInput
        name="addressLine"
        label="Street address"
        helperText="Street name and number."
      />
      <TextInput
        name="addressLine2"
        label="Address line 2"
        helperText="Floor, door or building. Leave empty if not needed."
      />
    </FormRow>
    <FormRow>
      <TextInput name="postcode" label="Postcode" />
      <TextInput name="city" label="City" />
    </FormRow>
  </div>
);
